/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React, { createContext, type ReactNode, type Context as ContextType } from 'react';

type ContextObjName = string;
type Props<T> = {
	children: (value: T) => ReactNode | null | undefined;
};

type ProviderProps<T> = {
	value: T;
	children: ReactNode | null | undefined;
};

const createSafeContext = <T,>(name: ContextObjName): ContextType<T> => {
	const contextObjName = name || '';
	const defaultGetter = (): T => {
		throw new Error(
			`The Consumer for ${contextObjName} Context Object does not have a correct value. Maybe, it needs to be wrapped in its corresponding Provider`,
		);
	};
	const Context = createContext(defaultGetter);
	const ContextConsumer = (props: Props<T>) => (
		<Context.Consumer>
			{(getValue) => {
				const value: T = getValue();
				return props.children(value);
			}}
		</Context.Consumer>
	);

	const ContextProvider = ({ value, children }: ProviderProps<T>) => {
		const getValue = (): T => value;
		return <Context.Provider value={getValue}>{children}</Context.Provider>;
	};
	ContextProvider.displayName = `${contextObjName}SafeProvider`;
	ContextConsumer.displayName = `${contextObjName}SafeConsumer`;
	// @ts-expect-error - TS2741 - Property '$$typeof' is missing in type '{ ({ value, children }: ProviderProps<T>): JSX.Element; displayName: string; }' but required in type 'ProviderExoticComponent<ProviderProps<T>>'. | TS2741 - Property '$$typeof' is missing in type '{ (props: Props<T>): JSX.Element; displayName: string; }' but required in type 'ExoticComponent<ConsumerProps<T>>'.
	return { Provider: ContextProvider, Consumer: ContextConsumer };
};

export default createSafeContext;
